
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'MM_R_ISS',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/HD/MM_R_ISS.vue